import ActionTypes from "../constants/ActionTypes";

const initialState = {
    hasError: false,
    errorMessage: '',
    isLoading: false,
    isSuccess: false,
    applyData: null,
    isMultipleLanguage: false
};

export default (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case ActionTypes.GUEST_APPLY_SETTING_REQUEST:
            return {
                ...state,
                isSuccess: false,
                isLoading: true,
                hasError: false
            };
        case ActionTypes.GUEST_APPLY_SETTING_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                isLoading: false,
                hasError: false
            };
        case ActionTypes.GET_GUEST_APPLY_SETTING_SUCCESS:
            return {
                ...state,
                applyData: action.payload,
                isSuccess: true,
                isLoading: false,
                hasError: false
            };
        case ActionTypes.GUEST_APPLY_SETTING_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false,
                isSuccess: false,
                errorMessage: action.errorMessage
            };
        case ActionTypes.GUEST_APPLY_SETTING_RESET:
            return {
                ...initialState
            };
        default:
            return state;
    }
};
